'use strict'
/**
 * Attention!
 * Cyrillic comments in this file cause an error when "concatenateModules" is enabled
 */
import Fitting from './fitting';

function fitInit() {
    if (!document.getElementById('fit')) return

    let pixelRatio = null
    // new Fit() needs to be assigned to something, otherwise it won't launch in Safari.
    let itemFit = new Fitting({
        setButtonText: false,

        elementId: 'fit',
        classActive: 'fitting-controls__button_active',
        sizeQuerySelector: '.js-size-field',
        pixelRatio: pixelRatio,
        manHand: 'img/fitting/fit-popup__hand__man.png',
        womanHand: 'img/fitting/fit-popup__hand__woman.png',
        manXl: 70,
        womanXl: 60,
        manHandImageWristWidth: 212,
        womanHandImageWristWidth: 183,
        wristCenterX: 441,
        wristCenterY: 328,
        margin: 10,
        step: 5,
        size: 'm',
        side: 'left',
    })
    // Handle hand change event
    itemFit.on('hand_change', event => {

        let fittingInfo = document.querySelector('.fitting-popup__info')
        if (fittingInfo) {
            if (event.detail.hand === 'left') {
                fittingInfo.classList.replace('fitting-popup__info_right', 'fitting-popup__info_left')
            } else {
                fittingInfo.classList.replace('fitting-popup__info_left', 'fitting-popup__info_right')
            }
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    fitInit()
})

try {
    BX.addCustomEvent('onComponentAjaxHistorySetState', () => {
        $(document).ready(function () {
            fitInit();
        });
    });

    BX.addCustomEvent('onComponentAjaxHistoryGetState', function () {
        // When navigating with browser buttons (in ajax mode) when ajax is received
        fitInit();
    });
} catch (error) {
    console.warn('BX is not defined. Custom events will not be registered.', error);
}